export default __webpack_public_path__ + "static/media/product-20.2c6815c6.jpg";